import type { ReactNode } from "react";

/**
 * Ported from the ZNMS admin, with the palette swapped for the tokens in
 * docs/09-theme.md so a badge and the chart beside it agree on what "warning"
 * looks like in both themes.
 *
 * Colour is never the only carrier: every badge renders a word.
 */

export type BadgeKind = "positive" | "critical" | "warning" | "neutral" | "info";

const KIND_STYLES: Record<BadgeKind, { color: string; background: string }> = {
  positive: {
    color: "var(--chart-ok)",
    background: "color-mix(in srgb, var(--chart-ok) 14%, transparent)",
  },
  critical: {
    color: "var(--chart-crit)",
    background: "color-mix(in srgb, var(--chart-crit) 14%, transparent)",
  },
  warning: {
    color: "var(--chart-warn)",
    background: "color-mix(in srgb, var(--chart-warn) 14%, transparent)",
  },
  info: {
    color: "var(--azure-deep)",
    background: "color-mix(in srgb, var(--azure-deep) 12%, transparent)",
  },
  neutral: { color: "var(--ink-soft)", background: "var(--chip-bg)" },
};

export function Badge({
  kind = "neutral",
  children,
  title,
}: {
  kind?: BadgeKind;
  children: ReactNode;
  title?: string;
}) {
  return (
    <span
      title={title}
      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-line px-2 py-0.5 text-xs font-semibold"
      style={KIND_STYLES[kind]}
    >
      {children}
    </span>
  );
}
